import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { semanticColors } from '../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class InvoiceSummary extends Component {
    summaryRow = (title, sum) => {
        return (
            <div
                style={{
                    display: 'flex',
                    display: '-webkit-flex',
                    flexDirection: 'row',
                    width: 400,
                    backgroundColor: 'white',
                    minHeight: 35
                }}
            >
                <div
                    style={{ width: '40%', borderBottom: '1px solid ' + semanticColors.mainBackground, padding: 5 }}
                >
                    {title}
                </div>
                <div
                    style={{ width: '60%', borderBottom: '1px solid ' + semanticColors.mainBackground, padding: 5, textAlign: 'right' }}
                >
                    {sum ? sum.toFixed(2).toString().replace('.00', '').replace('.', ',') : sum === "" ? "" : '-'}
                </div>
            </div>
        )
    }

    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }

    handleDotAndCommaNumber(input) {
        if (input.indexOf('.') > -1 && input.indexOf(',') > -1) {
            input = input.replace('.', '')
        }
        input = input.replace('.', ',')
        return input
    }

    render() {
        let regning = 0
        let tilbud = 0
        this.props.usage.forEach((u) => {
            regning += this.parseAndCalcSum(u.amount, u.price ? u.price : 0)
        })
        for (var key in this.props.crew) {
            if (this.props.crew.hasOwnProperty(key)) {
                const row = this.props.crew[key]
                if(row && row.sum) {
                    const s = parseFloat(row.sum.toString().replace(',', '.'))
                    if(!isNaN(s)) {
                        regning +=s
                    }
                }
            }
        }

        this.props.offers.forEach((r) => {
            let sum = parseFloat(r[3].replace(',', '.')) * parseFloat(r[4].replace(',', '.'))
            if (sum) {
                sum = sum.toFixed(2).replace('.00', '').replace('.', ',')
            }
            if (sum) {
                tilbud += parseFloat(sum.replace(',', '.'))
            }
        })

        this.props.measurements.forEach((m) => {
            regning += this.parseAndCalcSum(m.price ? m.price : 0, m.amount)
        })
        this.props.activities.forEach((r) => {
            regning += this.parseAndCalcSum(r.totalHours, (r.price ? r.price : 0))
        })

        this.props.deliveryNotes.map((row, index) => {
            regning += ((row.price ? parseFloat(row.price.toString().replace(',', '.')) : 0) * ((((row.percentage ? parseFloat(row.percentage.toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100)
        })

        if (this.props.others) {
            this.props.others.forEach((r) => {
                let sum = parseFloat(r[3].replace(',', '.')) * parseFloat(r[4].replace(',', '.'))
                if (sum) {
                    sum = (((sum ? parseFloat(sum.toString().replace(',', '.')) : 0) * (((r[7] ? parseFloat(r[7].toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100).toFixed(2).toString().replace('.00', '').replace('.', ',')                
                }
                if (sum) {
                    regning += parseFloat(sum.replace(',', '.'))
                }
            })
        }

        let bilag = 0
        this.props.invoices.map((row, index) => {
            bilag += (((row.price ? parseFloat(row.price.toString().replace(',', '.')) : 0) * (((row.til ? parseFloat(row.til.toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100)
        })

        const c = this.summaryRow("I alt øvrige", tilbud)
        const c2 = this.summaryRow("I alt regningsarbejder", regning)
        const c3 = this.summaryRow("Bilag", bilag)
        const c4 = this.summaryRow("", "")
        const c5 = this.summaryRow("I alt", regning + tilbud + bilag)


        return (
            <div
                style={{
                    display: 'flex',
                    display: '-webkit-flex',
                    flexDirection: 'column',
                    width: 400,
                }}
            >
                {c}
                {c2}
                {c3}
                {c4}
                {c5}
            </div>
        )
    }
}

InvoiceSummary.propTypes = propTypes

InvoiceSummary.defaultProps = defaultProps

export default InvoiceSummary;


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/summary.js